module.exports = __webpack_public_path__ + "static/img/doomyoga circle.f20473c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/doomyoga circle.png
// module id = xSxz
// module chunks = 0